import { bool, string } from "prop-types";

import __ from "web/Layout/Translations";

import classes from "./labels.scss";

const CheckoutSubscriptionLabels = ({ extendedView, benefitGroupType }) => {
  const isThatGroupTwo = benefitGroupType === "2";
  const tableColumns = {
    employerColumn: isThatGroupTwo ? "Źródło finansowania" : "Koszt pracodawcy",
    employeeColumn: isThatGroupTwo ? "Koszt" : "Koszt pracownika",
  };

  return (
    <header className={classes.root}>
      <div className={classes.name}>{__("Rodzaj abonamentu")}</div>
      <div className={classes.additional}>
        <div className={classes.label}>{__("Liczba osób")}</div>
        {extendedView ? (
          <>
            <div className={classes.label}>
              {__(tableColumns.employerColumn)}
            </div>
            <div className={classes.label}>
              {__(tableColumns.employeeColumn)}
            </div>
            {isThatGroupTwo && (
              <div className={classes.label}>Okres ważności</div>
            )}
          </>
        ) : null}
      </div>
    </header>
  );
};

CheckoutSubscriptionLabels.propTypes = {
  extendedView: bool.isRequired,
  benefitGroupType: string.isRequired,
};

export default CheckoutSubscriptionLabels;
